import { useSearchParams } from "react-router-dom";
import { ServerErrorPage, SERVER_ERROR_MAP } from "./server-error-page";

export function ServerErrorRoute() {
  const [searchParams] = useSearchParams();
  const status = Number(searchParams.get("status") || 500);
  const validStatus = status in SERVER_ERROR_MAP ? (status as 500 | 502 | 503) : 500;

  return <ServerErrorPage status={validStatus} />;
}
